import {Model} from '@vuex-orm/core';

export abstract class StembleModel extends Model {}
